module.exports = __webpack_public_path__ + "img/img4.ac4104d5.png";